export const FeatureTileVariants = {
  campaign: 'campagin',
  adGroup: 'ad group',
  keyword: 'keyword',
};
